import { render, staticRenderFns } from "./FileChooser.vue?vue&type=template&id=fbca3b28"
import script from "./FileChooser.vue?vue&type=script&lang=js"
export * from "./FileChooser.vue?vue&type=script&lang=js"
import style0 from "./FileChooser.vue?vue&type=style&index=0&id=fbca3b28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports